import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=93a0d5a4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Crm.vue"
export default component.exports